/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/

import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import * as _ from 'lodash';
import { AppUtilityService } from '../../services/app-utility.service';
import { TerminalCommonInfo } from './../../../core/model/terminal-common-info.model';
import { LmsException } from './../../model/lms-exception.model';
import { ShopLocation } from './../../model/shop-location.model';
import { TripPlanException } from './../../model/trip-plan-exception.model';
import { StaticDataStoreService } from './../../services/static-datastore.service';



/**
 * @export
 * @class LmsBreExceptionComponent
 * @implements {OnInit}
 * @implements {OnChanges}
 */
@Component({
  selector: 'lms-bre-exception',
  templateUrl: './lms-bre-exception.component.html',
  styleUrls: ['./lms-bre-exception.component.scss']
})
export class LmsBreExceptionComponent implements OnInit, OnChanges {

  @Input() lmsException: LmsException;
  @Output() checkCheckedLoco: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() tabLevel: number;
  tripPlanExceptionArr: Array<TripPlanException>;
  qShopLocationArr: Array<ShopLocation>;
  selectedTripPlanExceptionCode: string;
  selectedTripPlanExceptionDesc: string;
  selectedShopLocationCode: string;
  selectedShopLocationDesc: string;
  selectedUnschdQDate: string;
  tripPlanOtherReason: string;
  displayOtherDesc: string;
  selectedQShopDateDesc: string;
  selectedLoco: boolean;
  displayLocoId: string;
  filteredResults: string[] = [];
  terminalSearchText: string;
  summary: TerminalCommonInfo;
  commonopsPicklist: any;

  /**
   * Creates an instance of LmsBreExceptionComponent.
   * @param {StaticDataStoreService} staticDataStoreService
   * @param {AppUtilityService} appUtilityService
   * @memberOf LmsBreExceptionComponent
   */
  constructor(private staticDataStoreService: StaticDataStoreService,
    private appUtilityService: AppUtilityService) { }

  /**
   * Initialize the state of lifecycle hook.
   * @memberOf LmsBreExceptionComponent
   */
  ngOnInit() {
    this.tripPlanExceptionArr = [];
    this.qShopLocationArr = [];
    this.selectedTripPlanExceptionDesc = 'Select';
    this.selectedQShopDateDesc = 'Select';
    if (this.lmsException && !this.lmsException.isSelectedLoco) {
      this.selectedLoco = false;
    } else {
      this.selectedLoco = true;
    }
    if (this.lmsException && this.lmsException.deadDate) {
      const deadDate = this.lmsException.deadDate.substring(2, 4) + '-' + this.lmsException.deadDate.substring(4, 6) +
        '-' + this.lmsException.deadDate.substring(0, 2);
      this.lmsException.deadDate = deadDate;
    }

    if (this.lmsException && this.lmsException.locoId) {
      this.displayLocoId = this.appUtilityService.formatLocomotiveIdForDispaly(this.lmsException.locoId);
    }

    this.commonopsPicklist = this.staticDataStoreService.getValue('commonopsPicklist');
    if (this.commonopsPicklist && this.commonopsPicklist.masterData) {
      if (this.commonopsPicklist.masterData.tripPlanExceptionList) {
        this.tripPlanExceptionArr = this.commonopsPicklist.masterData.tripPlanExceptionList;
        this.selectedTripPlanExceptionCode = this.commonopsPicklist.masterData.tripPlanExceptionList[0].reasonCode;
      }
      if (this.commonopsPicklist.masterData.shopLocationList) {
        this.qShopLocationArr = this.removeDuplicates(this.commonopsPicklist.masterData.shopLocationList, 'shopCode');
      }
    }
    if (this.lmsException && this.lmsException.unschdQDateSelectionDate && this.lmsException.unschdQDateSelectionDate.length > 0) {
      this.selectedUnschdQDate = this.lmsException.unschdQDateSelectionDate[0];
      this.lmsException.unschdQDateSelectionDate = this.lmsException.unschdQDateSelectionDate.filter((str) => {
        return (str !== '');
      });
    }
  }

  /**
   * Invoked when changes in lifecycle hook.
   * @memberOf LmsBreExceptionComponent
   */
  ngOnChanges() {
    const firstElem = document.getElementById('brePopFirstElement');
    if (firstElem) {
      firstElem.focus();
    }
  }

  /**
   * Remove dublicate prop. element form array
   * @param {any} myArr
   * @param {any} prop
   * @returns
   * @memberOf LmsBreExceptionComponent
   */
  removeDuplicates(myArr, prop) {
    return _.uniqBy(myArr, prop);
  }

  /**
   * Submit trip plan from popup.
   * @memberOf LmsBreExceptionComponent
   */
  submitTripPlanException() {
    if (this.selectedTripPlanExceptionCode !== 'Other') {
      this.lmsException.tripPlanOverrideCode = this.selectedTripPlanExceptionCode;
      const tripPlanException = _.find(this.tripPlanExceptionArr,
        { 'reasonCode': this.selectedTripPlanExceptionCode });
      this.selectedTripPlanExceptionDesc = tripPlanException.reasonDescription;
      this.lmsException.tripPlanOverrideReason = this.selectedTripPlanExceptionDesc;
      this.displayOtherDesc = '';
      this.tripPlanOtherReason = '';
    } else {
      this.lmsException.tripPlanOverrideCode = 'TEXT'; // AS PER VB shop code
      this.selectedTripPlanExceptionDesc = 'Other';
      this.lmsException.tripPlanOverrideReason = this.tripPlanOtherReason;
      this.displayOtherDesc = this.tripPlanOtherReason;
    }
  }

  /**
   * Submit Q shop location.
   * @memberOf LmsBreExceptionComponent
   */
  submitQShopLocation() {
    const shopLocation = _.find(this.qShopLocationArr,
      { 'shopCode': this.selectedShopLocationCode });
    if (shopLocation) {
      this.lmsException.unscheduledQShopDate = this.selectedUnschdQDate;
      this.selectedQShopDateDesc = shopLocation.terminalMnemonic + '-' + shopLocation.shopCode + ' ' + this.selectedUnschdQDate;
    } else {
      this.selectedQShopDateDesc = 'Select';
    }
  }

  /**
   * Invoked when click on checkbox in front of loco.
   * @memberOf LmsBreExceptionComponent
   */
  changeSelectLoco() {
    if (this.selectedLoco) {
      this.lmsException.isSelectedLoco = true;
      this.checkCheckedLoco.emit(true);
    } else {
      this.lmsException.isSelectedLoco = false;
      this.checkCheckedLoco.emit(false);
    }
  }

  locoSelection() {
    if (this.selectedLoco) {
      this.selectedLoco = false;
    } else {
      this.selectedLoco = true;
    }
    this.changeSelectLoco();
  }

  /**
   * Autocomplete for terminal selection.
   * @param {any} event
   * @memberOf LmsBreExceptionComponent
   */
  autoCompleteForTerminal(event) {
    const mnemonics = [];
    if (this.commonopsPicklist) {
      if (this.commonopsPicklist.masterData && this.commonopsPicklist.masterData.shopLocationList) {
        for (let i = 0; i < this.commonopsPicklist.masterData.shopLocationList.length; i++) {
          mnemonics.push(this.commonopsPicklist.masterData.shopLocationList[i].terminalMnemonic);
        }
      }
    }
    this.filteredResults = mnemonics.filter((s) => {
      return s.startsWith(event.query.toUpperCase());
    });

    this.filteredResults = this.filteredResults.filter(function (item, index, inputArray) {
      return inputArray.indexOf(item) === index;
    });
    this.filteredResults.sort();
  }

  /**
   * Select terminal menmonic from autocomplete terminal mnemonic.
   * @param {string} value
   * @memberOf LmsBreExceptionComponent
   */
  selectValueFromAutoComplete(value: string) {
    if (value) {
      if (this.commonopsPicklist && this.commonopsPicklist.setOfTerminals) {
        const terminalCommonInfoArr = this.commonopsPicklist.setOfTerminals;
        if (terminalCommonInfoArr) {
          this.summary = _.find(terminalCommonInfoArr,
            { 'terminalMnemonic': value.trim().toUpperCase() });
          if (this.summary) {
            if (this.summary.city) {
              this.summary.city = this.summary.city.trim();
            }
            if (this.commonopsPicklist.masterData && this.commonopsPicklist.masterData.divisonList) {
              const divisionArr = this.commonopsPicklist.masterData.divisonList;
              if (divisionArr && this.summary) {
                const divisionObj: TerminalCommonInfo = _.find(divisionArr, { 'divisionCode': this.summary.divisionCode });
                if (divisionObj) {
                  this.summary.divisionName = divisionObj.divisionName;
                }
              }
            }
          }
        }
      }
      const shopLocation = _.find(this.qShopLocationArr,
        { 'terminalMnemonic': value });
      if (shopLocation) {
        this.selectedShopLocationCode = shopLocation.shopCode;
        this.lmsException.unscheduledQShop = shopLocation.shopCode;
      }
    }
  }

  /**
   * Remove search text on terminal mnemonic.
   * @memberOf LmsBreExceptionComponent
   */
  removeSearchText() {
    this.selectedShopLocationCode = '';
    this.terminalSearchText = '';
    this.summary = null;
  }

  /**
   * Update terminal search text as per model changes.
   * @param {any} event
   * @memberOf LmsBreExceptionComponent
   */
  updateTerminalSearchText(event) {
    const shopLocation = _.find(this.qShopLocationArr,
      { 'terminalMnemonic': event });
    if (shopLocation) {
      this.selectedShopLocationCode = shopLocation.shopCode;
      this.lmsException.unscheduledQShop = shopLocation.shopCode;
    }
  }
}
